import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function TopBanner() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 30,
    seconds: 0
  });
  const [showButton, setShowButton] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY;
      setIsScrolled(scrollPos > 50);
      setShowButton(scrollPos > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          return {
            hours: 0,
            minutes: 15,
            seconds: 0
          }; // Reset or stop
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const currentDate = new Date().toLocaleDateString('es-AR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  });
  const scrollToPricing = () => {
    const target = document.getElementById('pricing');
    if (!target) return;
    const start = window.scrollY;
    const end = target.getBoundingClientRect().top + start - 80;
    const duration = 2000;
    const startTime = performance.now();
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  return <div className="bg-gradient-to-r from-[#1e1b4b] via-[#312e81] to-[#1e1b4b] text-white py-1 px-4 sticky top-0 left-0 right-0 z-[70] border-b border-white/10 shadow-[0_4px_20px_rgba(0,0,0,0.3)]" data-id="element-379">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-2 text-[10px] md:text-xs font-bold uppercase tracking-wider" data-id="element-380">
        <div className="flex items-center gap-2 flex-1 justify-center md:justify-start" data-id="element-381">
          <AnimatePresence mode="wait" data-id="element-382">
            {!isScrolled && <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="flex items-center text-[8px] md:text-[10px] gap-[6px]" data-id="element-383">
                <span className="bg-[#00f0ff] text-black px-1.5 py-0.5 rounded whitespace-nowrap shadow-[0_0_8px_rgba(0,240,255,0.4)] text-[10px]" data-id="element-384">
                  OFERTA VÁLIDA:
                </span>
                <span className="font-black whitespace-nowrap text-white/90 text-[10px]" data-id="element-385">
                  {currentDate}
                </span>
              </motion.div>}
          </AnimatePresence>

          <div className={`flex items-center gap-2 transition-all duration-300 ${isScrolled ? 'mx-auto' : 'ml-0 md:ml-auto'}`} data-id="element-386">
            <div className="flex items-center gap-1 text-white/70" data-id="element-387">
              <Timer className="w-3.5 h-3.5 text-[#00f0ff] animate-pulse bg-[#0A34F1]" data-id="element-388" />
              <span className="hidden sm:inline text-[9px]" data-id="element-389">TERMINA EN:</span>
            </div>
            <div className="flex gap-0.5 font-mono text-sm md:text-base bg-white/5 px-2 py-0.5 rounded border border-white/10 shadow-inner" data-id="element-390">
              <span className="font-black drop-shadow-[0_0_5px_rgba(0,240,255,0.5)] text-[#F7FEFE]" data-id="element-391">
                {formatNumber(timeLeft.minutes)}
              </span>
              <span className="text-white/30 animate-pulse" data-id="element-392">:</span>
              <span className="font-black drop-shadow-[0_0_5px_rgba(0,240,255,0.5)] text-[#F5F9F9]" data-id="element-393">
                {formatNumber(timeLeft.seconds)}
              </span>
            </div>
          </div>
        </div>

        <AnimatePresence data-id="element-394">
          {showButton && <motion.button initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: 20
        }} whileHover={{
          scale: 1.05,
          backgroundColor: '#000',
          color: '#fff'
        }} whileTap={{
          scale: 0.95
        }} onClick={scrollToPricing} className="md:text-xs px-4 py-2 rounded-full shadow-lg transition-all border border-black/20 whitespace-nowrap text-[11px] font-[900] text-[#F9F5F5] bg-[#EEA300]" data-id="element-395">
              VER OFERTA
            </motion.button>}
        </AnimatePresence>
      </div>
    </div>;
}